<template>
<div>
    <!-- <view-header title="Truck Assignment" description="Assign trucks to driver"/> -->
    <v-col no-gutters style="padding: 24px;">
         <div class="mb-4">
             <div class="upper-text body-2 font-weight-medium">Search for truck</div>
         </div>
        <v-row no-gutters>
            <multiselect v-if="!loading"
                v-model="driver.driverTrucks" 
                :placeholder="`Search for truck`" 
                label="truckIdentifier" 
                track-by="truckIdentifier" 
                :options="trucks" 
                :multiple="true" 
                :taggable="true"
                :hide-selected="true"
                :class="generateChipStyle('orange')"
                style="background:none !important; "
            >
            </multiselect>
            <v-spacer></v-spacer>
            <trucks :showCardView="false"></trucks>
        </v-row>
    </v-col>
</div>
</template>
<script>
import Trucks from '../../views/Trucks'
import multiselect from 'vue-multiselect'
import request from '@/store/helpers'
import MultiSelectChipStyle from '../../mixins/multiselect_chip_style'
export default {
    props:['driver_id','driver'],
    mixins:[MultiSelectChipStyle],
    data(){
        return {
            loading:true,
            trucks:[]
        }
    },
    components:{Trucks,multiselect},
    model:{
        prop:'driver',
        event: 'changed'
    },
    methods:{
        reloadAvailableTrucks() {
            //load the trucks available to be assigned for this driver
            //var url = `/trucks/availableTrucks`
            var url = `truck/list`
            axios({
                method:"GET",
                url:`${process.env.VUE_APP_baseURL}${url}`,
            }).then(response=>{
                console.log(response)
                this.trucks = response.data.data
                console.log(this.trucks)
                this.loading = false
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`)
            })
        }
    },
    mounted(){
        if(this.driver_id !== undefined && this.driver_id !== null) {
            this.reloadAvailableTrucks()
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>